import { render, staticRenderFns } from "./InsurancePanel.vue?vue&type=template&id=02ef6270&scoped=true"
import script from "./InsurancePanel.vue?vue&type=script&lang=js"
export * from "./InsurancePanel.vue?vue&type=script&lang=js"
import style0 from "./InsurancePanel.vue?vue&type=style&index=0&id=02ef6270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ef6270",
  null
  
)

export default component.exports